
import React, { createContext, useContext, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllLanguages, fetchLanguages, fetchAllCountries, fetchPlaceholder, fetchSelectedPlaceholder } from "../store/apiActions";
import { env } from "../environment";
import { encrypted } from "../utils/Utility";
import { useLocation } from "react-router-dom";

const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [manualLanguageSelected, setManualLanguageSelected] = useState(false);
  const [manualCountrySelected, setManualCountrySelected] = useState(false);
  const countries = useSelector((state) => state?.api?.allCountriesDetail?.data || []);
  const languages = useSelector((state) => state?.api?.allLanguages?.data || []);
  const translations = useSelector((state) => state.api.allTranslatedLanguages?.data || {});
  const placeholderLanguage = useSelector((state) => state.api.placeholderLanguage?.data || {});
  const selectedPlaceholderLanguage = useSelector((state) => state.api.selectedPlaceholderLanguage?.data || {});
  
  const location = useLocation();

  useEffect(() => {
    if (countries?.length > 0 && !selectedCountry) {
      setSelectedCountry(countries[0]);
      encrypted.setEncryptedItem("country", countries[0]);
    }
  }, [countries, selectedCountry]);

  useEffect(() => {
    const navEntry = performance.getEntriesByType("navigation")[0];
    if (navEntry?.type === "reload") {
      setManualLanguageSelected(false);
      localStorage.setItem("manualLanguageSelected", "false");
    } else {
      const manualLang = localStorage.getItem("manualLanguageSelected");
      if (manualLang === "true") {
        setManualLanguageSelected(true);
        localStorage.setItem("manualLanguageSelected", "true");
      }
    }
  }, []);

  useEffect(() => {
    const isLoggedIn = !!encrypted.getDecryptedItem("startSession");
    if (!isLoggedIn && (location.pathname === "/sign-in" ||location.pathname === "/")) return;
  
    dispatch(fetchLanguages(`${env.baseURL}/get-languages?language=${selectedLanguage}`));
    dispatch(fetchAllLanguages(`${env.baseURL}/get-translations?language=${selectedLanguage}`));
    dispatch(fetchAllCountries(`${env.baseURL}/get-countries?language=${selectedLanguage}`));
    dispatch(fetchPlaceholder(`${env.baseURL}/get-placeholder-language?language=${selectedLanguage}`));
    dispatch(fetchSelectedPlaceholder(`${env.baseURL}/get-selected-placeholder-language?language=${selectedLanguage}`));
  }, [dispatch, selectedLanguage, location.pathname]);
  


  useEffect(() => {
    encrypted.setEncryptedItem(
      "language", selectedLanguage);
  }, [selectedLanguage]);

  return (
    <TranslationContext.Provider value={{ translations, countries, languages, selectedLanguage, placeholderLanguage, selectedPlaceholderLanguage, setSelectedLanguage, selectedCountry, setSelectedCountry, manualCountrySelected, manualLanguageSelected, setManualCountrySelected, setManualLanguageSelected }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslationContext = () => useContext(TranslationContext);
